import { DataTable, DataTableColumn } from "mantine-datatable";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { PAGE_SIZES } from "../../../constants/status";
import OrderService, { OrderListItem } from "../../order-list/services/order-service";

const statusMap: Record<number, { label: string; className: string }> = {
  5: { label: "Hoàn thành", className: "bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs" },
};

export default function RevenueDetails() {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(PAGE_SIZES[0]);
  const [dataTable, setDataTable] = useState<OrderListItem[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { fetch: listOrders, loading: loadingTable } = OrderService.list();
  const listOrdersRef = useRef(listOrders);
  useEffect(() => { listOrdersRef.current = listOrders; }, [listOrders]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const res = await listOrdersRef.current({
        page,
        limit,
        statuses: 5, // Chỉ lấy đơn hàng đã hoàn thành
      });
      if (!mounted) return;
      if (res && res.status === 200) {
        const data = res.data as any;
        setDataTable(data?.list || []);
        setTotalRecords(data?.total_record || 0);
      } else {
        setDataTable([]);
        setTotalRecords(0);
      }
    })();
    return () => { mounted = false; };
  }, [page, limit]);

  const columns: DataTableColumn<OrderListItem>[] = [
    {
      accessor: "",
      title: "STT",
      textAlignment: "center",
      width: 60,
      render: (_, index) => <span>{(page - 1) * limit + index + 1}</span>,
    },
    {
      accessor: "code",
      title: "Mã đơn",
      textAlignment: "center",
      render: ({ code }) => <span className="font-semibold">{code}</span>,
    },
    { accessor: "customer.name", title: "Khách hàng", textAlignment: "left" },
    { accessor: "branch.name", title: "Chi nhánh", textAlignment: "left" },
    {
      accessor: "status",
      title: "Trạng thái",
      textAlignment: "center",
      render: ({ status }) => {
        const info = statusMap[Number(status)] || {
          label: "Không xác định",
          className: "bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-xs",
        };
        return <span className={info.className}>{info.label}</span>;
      },
    },
    {
      accessor: "total_amount",
      title: "Tổng tiền",
      textAlignment: "right",
      render: ({ total_amount }) => (
        <span className="font-semibold">{Number(total_amount).toLocaleString()}₫</span>
      ),
    },
    { accessor: "created_at", title: "Thời gian", textAlignment: "center" },
  ];

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(dataTable);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DoanhThu");
    XLSX.writeFile(wb, "chi_tiet_doanh_thu.xlsx");
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 h-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Chi tiết doanh thu</h2>
        <div className="space-x-2">
          <button
            className="px-3 py-1 border rounded hover:bg-gray-100"
            onClick={exportExcel}
          >
            Xuất Excel
          </button>
        </div>
      </div>
      <div className="datatables">
        <DataTable
          fetching={loadingTable}
          withColumnBorders
          noRecordsText="Chưa có dữ liệu"
          highlightOnHover
          className="whitespace-nowrap table-hover"
          records={dataTable}
          columns={columns}
          totalRecords={totalRecords}
          recordsPerPage={limit}
          page={page}
          onPageChange={setPage}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={setLimit}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) =>
            `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`
          }
        />
      </div>
    </div>
  );
}
